// Constants
import { DefaultPagination, PageSize } from "../constants/GeneralConstants";

//urls
import {
  archiveRoadStretchUrl,
  createRoadStretchUrl,
  getRoadStretchesByIdsUrl,
  getRoadStretchesOfOrgUrl,
  restoreRoadStretchUrl,
  getRoadStretchInfoByIdUrl,
  roadStretchPriceRefreshUrl,
  updateRoadStretchMetaDataUrl,
  getRoadStretchesByCityIdUrl,
  updateRoadStretchUrl,
} from "../urls/OrgRoadStretchURL";

import {
  sendCreateOrUpdateRequest,
  sendGetRequest,
} from "../utils/api/apiUtils";
import AtlasClient from "../sdk/AtlasClient";

export async function getRoadStretchesData(
  cityId,
  isArchived,
  isDigitalMedias,
  arterialRoutes = [],
  mediaTypes = [],
  zones = [],
  freqOptLocations = []
) {
  // Here, If isArchived == true ==> Meaning we will only get archived RoadStretches
  // If isArchived == false ==> Meaning we will only get  un-archived RoadStretches
  // If isArchived == "" ==> Meaning we will get all RoadStretches
  // (Here,isArchived == "" param is skipped by serializeQueryParams in sendGetRequest,so we will get all RoadStretches )

  const headerParams = {
    "Content-Type": "application/json",
  };

  const params = {
    _ar: isArchived,
    _city: cityId,
    pn: DefaultPagination.pageNumber,
    ps: PageSize.cityRoadStretches,
  };

  // to get only digital medias on stretches
  if (isDigitalMedias) {
    params._is_digital = true;
  }

  const arterialRouteLength = arterialRoutes.length;
  const mediaTypeLength = mediaTypes.length;
  const zoneLength = zones.length;
  const freqOptLocationsLength = freqOptLocations.length;

  if (arterialRouteLength) {
    params._type = arterialRoutes;
  }

  if (mediaTypeLength) {
    params._media_type = mediaTypes;
  }

  if (zoneLength) {
    params._zone = zones;
  }

  if (freqOptLocationsLength) {
    params._location_name = freqOptLocations;
  }

  return sendGetRequest(
    getRoadStretchesByCityIdUrl,
    params,
    true,
    headerParams
  );
}

export async function getRoadStretchesByIds(stretchIds) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const roadStretchIds = stretchIds.join();

  const params = {
    ids: roadStretchIds,
  };

  return sendGetRequest(getRoadStretchesByIdsUrl, params, true, headerParams);
}

export async function getRoadStretchesOfOrg(
  isArchived,
  cityId,
  keyWord,
  pageNumber,
  pageSize
) {
  // Here, If isArchived == true ==> Meaning we will only get archived RoadStretches
  // If isArchived == false ==> Meaning we will only get  unarchived RoadStretches
  // If isArchived == "" ==> Meaning we will get all RoadStretches
  // (Here,isArchived == "" param is skipped by serializeQueryParams in sendGetRequest,so we will get all RoadStretches )
  const params = {
    pn: pageNumber || DefaultPagination.pageNumber,
    ps: pageSize || DefaultPagination.pageSize,
    _ar: isArchived,
  };

  if (keyWord) {
    params._kw = keyWord;
  }

  if (cityId) {
    params._city = cityId;
  }

  return sendGetRequest(getRoadStretchesOfOrgUrl, params);
}

export async function archiveRoadStretch(stretchId) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const url = archiveRoadStretchUrl.replace(":stretchId", stretchId);

  return sendCreateOrUpdateRequest(url, {}, true, "PUT", headerParams);
}

export async function restoreRoadStretch(stretchId) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const url = restoreRoadStretchUrl.replace(":stretchId", stretchId);

  return sendCreateOrUpdateRequest(url, {}, true, "PUT", headerParams);
}

export async function createRoadStretch(stretchName, segmentIds, navPath) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  // passing only unique ids array
  const uniqueSegmentIds = [...new Set(segmentIds)];
  const stretchBean = {
    name: stretchName,
    roadSegmentIds: uniqueSegmentIds,
    source: "navigation", // other option "custom"
    navPaths: navPath,
  };

  const url = createRoadStretchUrl;

  return sendCreateOrUpdateRequest(
    url,
    stretchBean,
    true,
    "POST",
    headerParams
  );
}

export async function getRoadStretchInfoByIdFn(stretchId) {
  const headerParams = {
    "Content-Type": "application/json",
  };
  const url = getRoadStretchInfoByIdUrl.replace(":stretchId", stretchId);

  return sendGetRequest(url, {}, true, headerParams);
}

// Price refresh for stretches
export async function roadStretchPriceRefreshFn(stretchId) {
  const url = roadStretchPriceRefreshUrl.replace(":stretchId", stretchId);

  return sendCreateOrUpdateRequest(url, {}, true, "PUT");
}

export async function updateRoadStretchMetaDataFn(roadStretchBean, stretchId) {
  const headerParams = {
    "Content-Type": "application/json",
  };
  return sendCreateOrUpdateRequest(
    updateRoadStretchMetaDataUrl.replace(":stretchId", stretchId),
    roadStretchBean,
    true,
    "PUT",
    headerParams
  );
}

export async function updateRoadStretchFn(
  stretchId,
  stretchName,
  segmentIds,
  navPath
) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  // passing only unique ids array
  const uniqueSegmentIds = [...new Set(segmentIds)];
  const stretchBean = {
    name: stretchName,
    roadSegmentIds: uniqueSegmentIds,
    source: "navigation", // other option "custom"
    navPaths: navPath,
  };

  const url = updateRoadStretchUrl.replace(":stretchId", stretchId);

  return sendCreateOrUpdateRequest(url, stretchBean, true, "PUT", headerParams);
}

export async function getMultipleRoutesFn(startLocationStr, endLocationStr) {
  return await AtlasClient.routingMultipleDirections(
    startLocationStr,
    endLocationStr
  );
}

// get waypoint route for start,mid,end points
export async function getWaypointsRouteFn(points) {
  return await AtlasClient.routingWaypointsDirections(points);
}
